import { StyleFunctionProps } from '@chakra-ui/react';
import Input from './input';

const baseStyle = {
  ...Input.baseStyle.field,
  paddingY: '4',
  lineHeight: 'short',
  maxH: '450px',
};

const variants = {
  outline: (props: StyleFunctionProps) => Input.variants.outline(props).field,
};

const sizes = {
  '2xs': Input.sizes['2xs'].field,
  xs: Input.sizes.xs.field,
  sm: Input.sizes.sm.field,
  def: Input.sizes.def.field,
  md: Input.sizes.md.field,
  lg: Input.sizes.lg.field,
  xl: Input.sizes.xl.field,
};

const defaultProps = {
  size: 'md',
  variant: 'outline',
};

export default {
  baseStyle,
  sizes,
  variants,
  defaultProps,
};
